import { styled } from "@mui/system";
import { Link } from "@mui/material";
import { forwardRef } from "react";
import { ReactComponent as Logo } from "@components/assets/candea.svg";

export const CandeaLogo = (props) => {
  return <Logo {...props} />;
};

const LogoLink = styled(Link)(({ theme }) => ({
  margin: "auto",
  paddingTop: "20px",
  paddingBottom: "20px",
}));

export const CandeaLink = forwardRef((props, ref) => {
  return (
    <LogoLink href="/">
      <CandeaLogo height="40" />
    </LogoLink>
  );
});
